import { MoreHorizontal, Pencil, Trash2, Building2 } from 'lucide-react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import type { VendorResponse } from '@signalvote/shared';

interface VendorCardProps {
  vendor: VendorResponse;
  onClick: () => void;
  onDelete: (vendorId: string) => void;
  onRename: (vendorId: string) => void;
}

export function VendorCard({ vendor, onClick, onDelete, onRename }: VendorCardProps) {
  return (
    <Card
      className="cursor-pointer card-interactive hover:ring-2 hover:ring-primary/50 hover:shadow-card-hover"
      onClick={onClick}
    >
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between">
          <div className="min-w-0 flex-1">
            <h3 className="font-semibold text-sm truncate">{vendor.name}</h3>
          </div>
          <DropdownMenu>
            <DropdownMenuTrigger asChild onClick={(e) => e.stopPropagation()}>
              <Button variant="ghost" size="sm" className="h-8 w-8 p-0 shrink-0">
                <MoreHorizontal className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
              <DropdownMenuItem onClick={() => onRename(vendor.id)}>
                <Pencil className="mr-2 h-4 w-4" />
                Rename Vendor
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                onClick={() => onDelete(vendor.id)}
                className="text-destructive focus:text-destructive"
              >
                <Trash2 className="mr-2 h-4 w-4" />
                Delete Vendor
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="flex items-center gap-2">
          <Building2 className="h-4 w-4 text-muted-foreground" />
          <span className="text-xs text-muted-foreground">
            {vendor.canvasserCount} {vendor.canvasserCount === 1 ? 'canvasser' : 'canvassers'}
          </span>
        </div>
      </CardContent>
    </Card>
  );
}
